import { useQuery } from 'react-query';
import { IImageThumbnail, ImageType } from '../../../Entities';
import ImageProcessingApi from '../../../api/ImageProcessingApi';
import { getUserInfo } from '../../../../../../../telemetry/utils';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { useTelemetryContext } from '../../../../../../../telemetry/telemetryContext';
import { ICurrency } from '../../../../../../../shared/localization/currency';

export type IExtraImageCost = {
    value: number;
    currency: ICurrency;
};

export type UploadableProductData = {
    id: number;
    name: string;
    numberOfImages: number;
    thumbnails: IImageThumbnail[];
    orderRowProductProperties: any[]; // TODO...
    extraImageCost: IExtraImageCost | null;
};

type IImagesQueryArgs = {
    orderId: number;
    user: AuthenticatedUser;
    enabled?: boolean;
};

export type GetImagesResponse = UploadableProductData[];
export let imagesQueryKey = 'customer-image-processing-page-get-images';

export function useImagesQuery({ orderId, user, enabled = true }: IImagesQueryArgs) {
    let { logger } = useTelemetryContext();

    let { data, isLoading } = useQuery<GetImagesResponse>(
        [imagesQueryKey, { orderId }],
        () => ImageProcessingApi.listImages(orderId, ImageType.EDITED),
        {
            useErrorBoundary: true,
            enabled,
            refetchInterval: (data) => {
                if (!data) {
                    return false;
                }

                let hasEmptyReferences = data.some((product) =>
                    product.thumbnails.some((thumbnail) => !thumbnail.reference)
                );

                return hasEmptyReferences ? 1500 : false;
            },
            onError: (error) => {
                let additionalInfo = {
                    origin: 'CustomerImageProcessingPage.Query.getImages',
                    userInfo: getUserInfo(user)
                };
                logger.logException(error, additionalInfo);
            }
        }
    );

    return { data: data != null ? data : null, isLoading };
}
